import {
    addCheckInAttendant,
    addJudge,
    addMediaAccount,
    deleteCheckInAttendant,
    deleteJudge,
    deleteMediaAccount,
} from '@/middlewares/services/competition.services'

/**
 * The three access roles an organizer invites by email (William, 15 Oct 2026: judge · check-in ·
 * media; the Live Judging roles stay on live/settings). `title` is the menu row and dialog title,
 * `noun` the role word, `intro` the one-line explanation (all checkIn.json keys); `listProp` is the
 * array on the /event/menu summary; `add` / `remove` the existing services (the backend sends the
 * invitation email and creates the scoring.fit account when needed).
 */
export const INVITE_ROLES = {
    judge: {
        key: 'judge',
        title: 'Invite a judge',
        noun: 'judge',
        intro: 'Judges enter the scores of their lane. An email is sent; a scoring.fit account is created if needed.',
        listProp: 'judge_account',
        add: addJudge,
        remove: deleteJudge,
    },
    'check-in-attendants': {
        key: 'check-in-attendants',
        title: 'Invite a check-in attendant',
        noun: 'check-in attendant',
        intro: 'Check-in attendants check athletes, volunteers and spectators in on site. An email is sent; a scoring.fit account is created if needed.',
        listProp: 'checkInAttendants',
        add: addCheckInAttendant,
        remove: deleteCheckInAttendant,
    },
    media: {
        key: 'media',
        title: 'Invite media',
        noun: 'media',
        intro: 'Media accounts upload photos to the event albums. An email is sent; a scoring.fit account is created if needed.',
        listProp: 'mediaAccounts',
        add: addMediaAccount,
        remove: deleteMediaAccount,
    },
}
